module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/estado-white.03a99ef7.svg";